import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getQaQuestionAskTags = () =>
  httpClient.get(apis.GET_QA_QUESTION_ASK_TAGS, null, { ignore: true });
export const doQuestionNew = (payload) =>
  httpClient.post(apis.QA_QUESTION_QUESTION_NEW, payload, { ignore: true });
export const doQuestionBulletNew = (payload) =>
  httpClient.post(apis.QA_QUESTION_BULLET_NEW, payload, { ignore: true });
export const doAnswerNew = (payload) =>
  httpClient.post(apis.QA_QUESTION_ANSWER_NEW, payload, { ignore: true });
